import { db } from '../firebase';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';

const blogsCollection = collection(db, 'blogs');

// Note: This service generates sitemap XML dynamically for client-side use.
// For static sitemap.xml served at /sitemap.xml, use the generateSitemap.js script in the root directory.
// Run `npm run generate-sitemap` from the client directory to generate the static file.

export const generateSitemap = async () => {
  try {
    const q = query(blogsCollection, where('status', '==', 'published'), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    const blogs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
    xml += '<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n';

    // Static pages
    const staticPages = [
      { loc: '/', priority: '1.0', changefreq: 'weekly' },
      { loc: '/products', priority: '0.8', changefreq: 'monthly' },
      { loc: '/sustainability', priority: '0.8', changefreq: 'monthly' },
      { loc: '/problemimpact', priority: '0.8', changefreq: 'monthly' },
      { loc: '/contactus', priority: '0.8', changefreq: 'monthly' },
      { loc: '/blog', priority: '0.9', changefreq: 'weekly' }
    ];

    const baseUrl = 'https://enteeon.firebaseapp.com';
    const currentDate = new Date().toISOString().split('T')[0];

    staticPages.forEach(page => {
      xml += '  <url>\n';
      xml += `    <loc>${baseUrl}${page.loc}</loc>\n`;
      xml += `    <lastmod>${currentDate}</lastmod>\n`;
      xml += `    <changefreq>${page.changefreq}</changefreq>\n`;
      xml += `    <priority>${page.priority}</priority>\n`;
      xml += '  </url>\n';
    });

    blogs.forEach(blog => {
      const lastmod = blog.updatedAt ? blog.updatedAt.toDate().toISOString().split('T')[0] : blog.createdAt.toDate().toISOString().split('T')[0];
      xml += '  <url>\n';
      xml += `    <loc>${baseUrl}/blog/${blog.slug}</loc>\n`;
      xml += `    <lastmod>${lastmod}</lastmod>\n`;
      xml += '    <changefreq>monthly</changefreq>\n';
      xml += '    <priority>0.6</priority>\n';
      xml += '  </url>\n';
    });

    xml += '</urlset>';

    return xml;
  } catch (error) {
    console.error('Error generating sitemap:', error);
    throw error;
  }
};

export const getSitemap = async () => {
  try {
    return await generateSitemap();
  } catch (error) {
    return '<?xml version="1.0" encoding="UTF-8"?><urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"></urlset>';
  }
};